import { cn } from "@/utils/style";

type Props = React.ComponentProps<"div">;

export function Copyright({ className, ...props }: Props) {
  return (
    <div className={cn("text-xs leading-relaxed text-muted-foreground/80", className)} {...props}>
      <p>
        © {new Date().getFullYear()}{" "}
        <a href="https://huntr.app" target="_blank" rel="noopener" className="font-medium underline underline-offset-2">
          Huntr
        </a>{" "}
        — Ethical recruitment for a better workforce.
      </p>
      <p className="mt-4">Huntr CV v{__APP_VERSION__}</p>
    </div>
  );
}
